import { ButtonBase, Divider, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { SuggestionResponseItem } from '../addressApi';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';

interface AddressSuggestionListProps {
    list: SuggestionResponseItem[] | null;
    onSelect: (item: SuggestionResponseItem) => void;
}

export const AddressSuggestionList: React.FC<AddressSuggestionListProps> = ({ list, onSelect }) => {
    const { t } = useTranslation();
    const handleSelect = React.useCallback(
        (item: SuggestionResponseItem) => () => {
            onSelect(item);
        },
        [onSelect]
    );
    // TODO: potentially move it to a separate component? Revisit
    const renderItem = React.useCallback(
        (item: SuggestionResponseItem) => (
            <ButtonBase
                key={item.title}
                onClick={handleSelect(item)}
                sx={{ width: '100%', display: 'block' }}
            >
                <Divider variant="middle" />
                <Box p={1} pl={2} display="flex" alignItems="center" justifyContent="space-between" flex={1}>
                    <Box>
                        {
                            <Typography sx={{ fontWeight: 700 }} align="left">
                                {item.title ?? item.line1}
                            </Typography>
                        }
                        <Typography sx={{ opacity: 0.7 }} align="left">
                            {item.title ? item.line1 : [item.city, item.postalCode].join(', ')}
                        </Typography>
                    </Box>
                    <ChevronRightIcon />
                </Box>
            </ButtonBase>
        ),
        [handleSelect]
    );
    if (!list) {
        return null;
    }
    return (
        <Box pt={1}>
            <Typography variant="h6" align="center" gutterBottom>
                {t('DELIVERY_MAP_ADDRESS_SUGGESTIONS_TITLE')}
            </Typography>
            {list.map(renderItem)}
        </Box>
    );
};
